<div id="container-perfume-engraving-selector">
    <div class="container-selector" [formGroup]="formGroup">
        <div class="engraving-title" i18n="@@hermes.product-page.engraving-title" role="heading" aria-level="3">
            Engraving
        </div>
        <div class="instruction" [translate]="instructionTranslateKey"></div>
        <ng-container formGroupName="infosPerfumeEngraving">
            @for (attribute of formAttributeList; track attribute; let i = $index) {

            <div class="container-input" [id]="attribute">
                <h-input
                    [controlName]="attribute"
                    [class.margin-input-regex-error]="inputIndexesError.includes(i - 1)"
                    [label]="placeholder(i + 1) | translate"
                    [id]="'input-area-' + attribute"
                    [ariaDescribedby]="'engraving-edition'"
                    [attr.aria-labelledby]="attribute"
                    [errorManagement]="false"
                    [maxLength]="nbCharsByLinePerfumeEngraving[i]"
                    [isUpperCase]="nbCharsByLinePerfumeEngraving[i] <= maxLengthForInitial"
                    [hasSuffix]="true">
                    @if (infosPerfumeEngravingControls[attribute].errors?.pattern) {
                    <h-message-block
                        [showBackground]="false"
                        [autoAddPadding]="false"
                        [ariaRole]="undefined"
                        type="error">
                        <ng-container>
                            <span i18n="@@hermes.product-page.engraving-error-message">Sorry, we do not allow : </span>
                            <span>{{ charactersInErrorByLine[i] }}</span>
                        </ng-container>
                    </h-message-block>
                    }
                </h-input>
            </div>

            }
        </ng-container>
        <div
            class="description"
            [class.margin-input-regex-error]="inputIndexesError.includes(formAttributeList.length - 1)">
            <div id="free-service-information" i18n="@@hermes.product-page.engraving-free-service"> Free service </div>
            <div i18n="@@hermes.product-page.engraving-exchange-return">
                Engraved product cannot be returned or exchanged.
            </div>
        </div>
    </div>
    <p class="sr-only" id="engraving-edition">
        <span i18n="@@hermes.product-page.engraving-title"> Engraving </span>
        <span>,</span>
        <span [translate]="instructionTranslateKey"></span>
        <span>,</span>
        <span i18n="@@hermes.accessibility.engraving-edition">Engraving, edition</span>
        <span>,</span>
        <span i18n="@@hermes.product-page.engraving-free-service">Free service</span>
        <span>,</span>
        <span i18n="@@hermes.product-page.engraving-exchange-return">
            Engraved product cannot be returned or exchanged.
        </span>
    </p>
</div>
